/* src/app/components/notification-center/notification-center.component.scss */
button .badge {
  display: inline-block;
  border-radius: 100px;
  background: #d81e05;
  color: white;
  width: 16px;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  top: 3px;
  right: 3px;
}
mat-toolbar {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1000;
}
.notifications .empty {
  padding: 50px 20px;
  opacity: 0.5;
}
.notifications .notification {
  padding: 10px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background: rgb(225, 245, 255);
  transition: background 0.5s ease;
}
.notifications .notification p {
  margin: 10px 0 5px;
  font-size: 0.9rem;
  line-height: 1.2rem;
}
.notifications .notification small {
  opacity: 0.5;
}
.notifications .notification.with-action {
  cursor: pointer;
}
.notifications .notification.opened {
  background: transparent;
  opacity: 0.75;
}
.notifications .notification:last-child {
  border-bottom: 0;
}
::ng-deep .mat-mdc-menu-content {
  padding: 0 !important;
}
::ng-deep .mat-mdc-menu-panel {
  min-width: 200px !important;
  max-width: 400px !important;
}
/*# sourceMappingURL=notification-center.component.css.map */
